import React from "react";
import "./FeaturedSuppliers.scss";

import supplier1 from "../../images/supplier-1.jpg";
import supplier2 from "../../images/supplier-2.jpg";
import supplier3 from "../../images/supplier-3.jpg";
import supplier4 from "../../images/supplier-4.jpg";
import supplier5 from "../../images/supplier-5.jpg";
import supplier6 from "../../images/supplier-6.jpg";

const suppliers = [
  {
    image: supplier1,
    name: "Susana Ortega",
    categories: ["Vestidos"],
    phone: "5522519379",
    displayPhone: "55 2251 9379",
    whatsapp: "https://wa.me/525522519379",
    facebook: "https://www.facebook.com/share/1SQj4XW2SZ/?mibextid=wwXIfr",
    instagram: "https://www.instagram.com/susanaortegacasademodas?igsh=ZXVkN3V5N3UycG12",
    tiktok:
      "https://www.tiktok.com/@susanaortegacasademodas?_r=1&_t=ZS-94rHNrX8zyc",
  },
  {
    image: supplier2,
    name: "Danyy Crash",
    categories: ["Diseño de Imagen"],
    phone: "5525076739",
    displayPhone: "55 2507 6739",
    whatsapp: "https://wa.me/525525076739",
    facebook: "https://www.facebook.com/share/1CaRa6n4n7/?mibextid=wwXIfr",
    instagram: "https://www.instagram.com/danyycrash?igsh=Z3VicTk1eWt6dmV1",
    tiktok: "https://www.tiktok.com/@danyycrash?_r=1&_t=ZS-94rI2J5qhMu",
  },
  {
    image: supplier3,
    name: "Black Star",
    categories: ["Academia de Danza"],
    phone: "5539076706",
    displayPhone: "55 3907 6706",
    whatsapp: "https://wa.me/525539076706",
    facebook: "https://www.facebook.com/share/1CPA5w4XW3/?mibextid=wwXIfr",
    instagram:
      "https://www.instagram.com/studioblackstar_?igsh=MTh5bnBodjBoeTgwMg==",
    tiktok: "https://www.tiktok.com/@academiablackstar?_r=1&_t=ZS-94rIDSusbas",
  },
  {
    image: supplier4,
    name: "Sandoval Fotografía",
    categories: ["Fotografía"],
    phone: "5531234743",
    displayPhone: "55 3123 4743",
    whatsapp: "https://wa.me/525531234743",
    facebook: "https://www.facebook.com/share/1AhnveVZn7/?mibextid=wwXIfr",
    instagram:
      "https://www.instagram.com/sandoval_photography_mx?igsh=MXhoeWRwcmV3ZW1mMA==",
    tiktok: "https://www.tiktok.com/@its.richard?_r=1&_t=ZS-94rIeYh0LHc",
  },
  {
    image: supplier5,
    name: "La Magia de tu Historia",
    categories: ["Story Book"],
    phone: "4661260386",
    displayPhone: "466 126 0386",
    whatsapp: "https://wa.me/524661260386",
    facebook: "https://www.facebook.com/share/1ANBHVvfYk/?mibextid=wwXIfr",
    instagram:
      "https://www.instagram.com/lamagiadetuhistoriaoficial?igsh=MWIxMHBnb3cxNHpwNw==",
    tiktok:
      "https://www.tiktok.com/@lamagiadetuhistoria?_r=1&_t=ZS-94rItQo5KU6",
  },
  {
    image: supplier6,
    name: "Eventos J&B",
    categories: ["Banquetes", "Mesas de Dulces", "Snacks"],
    phone: "5516140807",
    displayPhone: "55 1614 0807",
    whatsapp: "https://wa.me/525516140807",
    facebook: "https://www.facebook.com/share/1K1r8Bm84A/?mibextid=wwXIfr",
    instagram:
      "https://www.instagram.com/jyb_eventos.mx?igsh=MXBoaGw3MWptMjFpMw==",
    tiktok: "https://www.tiktok.com/@jb.eventosmx?_r=1&_t=ZS-94rJCLlBCI3",
  },
];

const FeaturedSuppliers = () => {
  return (
    <section className="featuredDreams" id="proveedores">
      <div className="container">
        <div className="featuredDreams__header">
          <span className="featuredDreams__tag">
            Proveedores que inspiran confianza
          </span>

          <h2>Conoce nuestros proveedores destacados</h2>

          <p>
            Descubre algunas de las opciones más destacadas dentro de Dreams XV
            y encuentra proveedores increíbles para hacer realidad una fiesta
            inolvidable.
          </p>
        </div>

        <div className="featuredDreams__slider">
          {suppliers.map((supplier, index) => (
            <article className="featuredDreams__card" key={index}>
              <div className="featuredDreams__image">
                <img src={supplier.image} alt={supplier.name} />
              </div>

              <div className="featuredDreams__content">
                <h3>{supplier.name}</h3>

                <div className="featuredDreams__categories">
                  {supplier.categories.map((category, categoryIndex) => (
                    <span
                      className="featuredDreams__category"
                      key={categoryIndex}
                    >
                      {category}
                    </span>
                  ))}
                </div>

                <p className="featuredDreams__phone">{supplier.displayPhone}</p>

                <a
                  href={supplier.whatsapp}
                  target="_blank"
                  rel="noreferrer"
                  className="featuredDreams__whatsapp"
                >
                  Contáctanos por WhatsApp
                </a>

                <div className="featuredDreams__socials">
                  {supplier.facebook && (
                    <a
                      href={supplier.facebook}
                      target="_blank"
                      rel="noreferrer"
                      aria-label={`Facebook de ${supplier.name}`}
                    >
                      Facebook
                    </a>
                  )}

                  {supplier.instagram && (
                    <a
                      href={supplier.instagram}
                      target="_blank"
                      rel="noreferrer"
                      aria-label={`Instagram de ${supplier.name}`}
                    >
                      Instagram
                    </a>
                  )}

                  {supplier.tiktok && (
                    <a
                      href={supplier.tiktok}
                      target="_blank"
                      rel="noreferrer"
                      aria-label={`TikTok de ${supplier.name}`}
                    >
                      TikTok
                    </a>
                  )}
                </div>
              </div>
            </article>
          ))}
        </div>
        {/*
          <div className="featuredDreams__footer">
            <a
              href="https://dreamsxv.com/catalogo.php"
              target="_blank"
              rel="noreferrer"
              className="featuredDreams__more"
            >
              Ver más y conocer todos nuestros proveedores por categorías
            </a>
          </div>
          */
        }
      </div>
    </section>
  );
};

export default FeaturedSuppliers;
